import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { LookupField } from '../../../components/lookup/LookupField';
import { InputSwitch } from 'primereact/inputswitch';
import './NotificationOccurrence.scss'
import { DataTable } from 'primereact/datatable';

export const NotificationOccurrenceForm = (props) => {
    return (
        <div className="notification-occurrence-body">
            <div className='notification-occurrence-lookup'>
                <label className='lxRequiredField'>Tipos de ocorrências</label>
                <LookupField
                    value={props.selectedRecords.length > 0
                        ? props.selectedRecords.length + " ocorrências selecionada"
                        : null}
                    placeholder="Selecione as ocorrências"
                    name="description"
                    field="description"
                    onComplete={props.lookupOccurrenceTypeOnComplete}
                    onInputFilter={props.lookupOccurrenceTypeOnInputFilter}
                    editDisabled={props.lookupOccurrenceType.editDisabled}
                    onSelectionChange={props.onSelectionChange}
                    onEditField={props.lookupOccurrenceTypeOnEdit}
                    onClick={props.lookupOccurrenceTypeOnClick}
                    visible={props.lookupOccurrenceType.visible}
                    modal={props.lookupOccurrenceType.modal}
                    header={props.lookupOccurrenceType.header}
                    onHide={props.lookupOccurrenceTypeOnHide}
                    onConfirm={props.lookupOccurrenceTypeOnConfirm}
                    onCancel={props.lookupOccurrenceTypeOnCancel}
                    records={props.lookupOccurrenceType.records}
                    columns={props.lookupOccurrenceType.columns}
                    totalRecords={props.lookupOccurrenceType.totalRecords}
                    sortOrder={props.lookupOccurrenceType.order}
                    sortField={props.lookupOccurrenceType.sortField}
                    first={props.lookupOccurrenceType.first}
                    rows={props.lookupOccurrenceType.rows}
                    onPage={props.lookupOccurrenceTypeOnPage}
                    onFilter={props.lookupOccurrenceTypeOnFilter}
                    onSort={props.lookupOccurrenceTypeOnOnSort}
                    isMultiple={true}
                />
            </div>

            <div className='notification-choices'>
                <label>Notificar via WhatsApp</label>
                <InputSwitch
                    checked={props.record.useWhatsAppNotification}
                    // disabled={props.selectedRecords.length === 0}
                    onChange={(e) => props.onUseWhatsAppNotification(e.value)}
                />
                {props.record.useWhatsAppNotification && (
                    <div className='whatsapp'>
                        <label className='lxRequiredField'>Número WhatsApp</label>
                        <InputMask value={props.record.phoneWhatsApp} name='phoneWhatsApp' id="phone" mask="(99) 9-9999-9999" placeholder="(99) 9-9999-9999" onChange={props.changeHandler}></InputMask>
                    </div>
                )}
                <label>Notificar via E-mail</label>
                <InputSwitch
                    checked={props.record.useEmailNotification}
                    // disabled={props.selectedRecords.length === 0}
                    onChange={(e) => props.onUseEmailNotification(e.value)}
                />
                {props.record.useEmailNotification && (
                    <div className='email'>
                        <label className='lxRequiredField'>E-mail</label>
                        <InputText value={props.record.email} name='email' type='email' placeholder='email@examle.com' onChange={props.changeHandler} />
                    </div>
                )}
            </div>
            {props.record.notificationOccurrences.length > 0 && (
                <div className='notification-records'>
                    <DataTable
                        value={props.selectedRecords.length > 0 ? props.selectedRecords : props.record.notificationOccurrences}
                        emptyMessage='Nenhuma ocorrência selecionada'
                        scrollHeight="300px"
                        scrollable={true}

                    >
                        {props.columnsSelectRecords}
                    </DataTable>
                </div>
            )}
        </div>
    )
}
